import { wget } from 'lodash';

export default function isSendingGroup(referral, groupId) {
  return wget(referral, 'referred_by_group.id') === groupId;
}
